import React, { useMemo, useState } from 'react';
import { Button } from '../ui/button';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from '../ui/dialog';
import { Badge } from '../ui/badge';
import { BookOpen, Info } from 'lucide-react';
import { RULES_REGISTRY } from './BusinessRulesBar';

export function CompactBusinessRules({ ruleKeys = ['totals_scope'], scopeItems = [], label = 'Business Rules', dataTestId = 'compact-business-rules' }) {
  const [open, setOpen] = useState(false);
  const rules = useMemo(() => ruleKeys.map((key) => RULES_REGISTRY[key]).filter(Boolean), [ruleKeys]);
  const visibleScope = scopeItems.filter(Boolean).slice(0, 2);

  return (
    <>
      <div className="flex items-center gap-2" data-testid={dataTestId}>
        {visibleScope.map((item) => (
          <Badge key={item} variant="outline" className="text-[10px] bg-slate-50 text-slate-600 border-slate-200">
            {item}
          </Badge>
        ))}
        <Button variant="outline" size="sm" className="h-8 rounded-full px-3 text-[11px]" onClick={() => setOpen(true)} data-testid={`${dataTestId}-open-button`}>
          <BookOpen className="h-3.5 w-3.5 mr-1.5" /> {label}
        </Button>
      </div>

      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="sm:max-w-2xl" data-testid={`${dataTestId}-dialog`}>
          <DialogHeader>
            <DialogTitle className="flex items-center gap-2"><Info className="h-4 w-4 text-[#800000]" /> Business Rules</DialogTitle>
            <DialogDescription>
              Quick reference for how this module calculates pipeline, invoicing, collections, and totals.
            </DialogDescription>
          </DialogHeader>
          <div className="space-y-4">
            {rules.map((rule) => (
              <div key={rule.title} className="rounded-xl border bg-slate-50 p-4">
                <h4 className="text-sm font-semibold text-slate-800">{rule.title}</h4>
                <p className="text-xs text-slate-600 mt-1">{rule.description}</p>
                <ul className="mt-3 space-y-1.5">
                  {rule.bullets.map((bullet) => (
                    <li key={bullet} className="text-xs text-slate-700 flex gap-2">
                      <span className="text-[#800000]">•</span>
                      <span>{bullet}</span>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
}
